module.exports = __webpack_public_path__ + "Linearicons-Free.ec161a74448ccf2c18be.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/vendors/by_hands/font-linearicons/fonts/Linearicons-Free.svg?w118d
// module id = ./src/assets/vendors/by_hands/font-linearicons/fonts/Linearicons-Free.svg?w118d
// module chunks = styles